export type StepperStep = {
  id: string;
  label: string;
};

export type StepStatus = "completed" | "current" | "upcoming";

export type ResolvedStep = {
  step: StepperStep;
  status: StepStatus;
  index: number;
};

export const resolveStepStatuses = (
  steps: StepperStep[],
  currentStepId: string,
): ResolvedStep[] => {
  const currentIndex = steps.findIndex((step) => step.id === currentStepId);

  return steps.map((step, index) => {
    // Unknown current id: nothing is reached yet, every step stays ahead
    if (currentIndex === -1) {
      return { step, status: "upcoming", index };
    }
    if (index < currentIndex) {
      return { step, status: "completed", index };
    }
    if (index === currentIndex) {
      return { step, status: "current", index };
    }
    return { step, status: "upcoming", index };
  });
};

export const isStepClickable = (status: StepStatus, hasHandler: boolean): boolean =>
  status === "completed" && hasHandler;
